import reduceReducers from "reduce-reducers";

import { apiModelOfflineFetchReducer } from "lib/reducers";
import { BILLING_RUN_DOCUMENT_ATTACHMENTS } from "constants/actionTypes";
import { deserializeBillingDocumentAttachmentIds } from "actions";

const fetch = apiModelOfflineFetchReducer(BILLING_RUN_DOCUMENT_ATTACHMENTS, {
  deserializer: deserializeBillingDocumentAttachmentIds,
  clearOnRequest: true,
});

const billingRunDocumentAttachmentIdsReducer = reduceReducers(fetch);

export default billingRunDocumentAttachmentIdsReducer;
